import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden bg-primary" data-id="element-77">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-grid-pattern opacity-30 pointer-events-none" data-id="element-78" />

      <div className="relative z-10 max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-79">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-80">
          <span className="inline-block text-xs md:text-sm text-accent tracking-[0.3em] uppercase mb-8 border border-accent/30 px-4 py-2 rounded-full" data-id="element-81">
            The Future of Strategy Consulting
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-text-light leading-[1.1] mb-8" data-id="element-82">
          Elite Strategy Talent.
          <br data-id="element-83" />
          <span className="italic text-text-muted font-light" data-id="element-84">On Demand.</span>
          <br data-id="element-85" />
          Without the £1M Price Tag.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="text-lg md:text-xl text-text-muted max-w-3xl mx-auto mb-12 leading-relaxed" data-id="element-86">
          Access the top 1% of global business minds—Harvard, Oxford, LBS,
          INSEAD—deployed against your most critical challenges.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} className="flex flex-col sm:flex-row items-center justify-center gap-6" data-id="element-87">
          <a href="#contact" className="w-full sm:w-auto bg-tertiary text-white px-8 py-4 text-sm uppercase tracking-widest font-medium hover:bg-tertiary/90 transition-colors duration-300 inline-block text-center" data-id="element-88">
            Get Started
          </a>
          <a href="#how-it-works" className="w-full sm:w-auto text-text-light text-sm uppercase tracking-widest border-b border-transparent hover:border-accent transition-colors duration-300 pb-1 inline-block text-center" data-id="element-89">
            Explore the Model
          </a>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center" data-id="element-90">
        <div className="w-[1px] h-16 bg-gradient-to-b from-tertiary/30 to-transparent" data-id="element-91" />
      </motion.div>
    </section>;
}